import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const TrainPerformanceChart = ({ title, chartData }) => {
  if (!chartData || !chartData.labels || chartData.labels.length === 0) return <p>No data available</p>;

  // Convert chartData.labels and chartData.datasets[0].data to recharts format
  const data = chartData.labels.map((label, index) => ({
    name: label,
    value: parseFloat(chartData.datasets[0].data[index].toFixed(1))
  }));

  const yDomain = chartData.datasets[0].label.includes('Rating') ? [0, 5] : ['auto', 'auto'];

  return (
    <>
      <div className="chart-header">
        <h3 className="chart-title">{title}</h3>
      </div>
      <div className="chart-wrapper">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 60 }}>
            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="var(--border-color)" />
            <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{fill: 'var(--text-secondary)', fontSize: 12}} angle={-45} textAnchor="end" />
            <YAxis domain={yDomain} axisLine={false} tickLine={false} tick={{fill: 'var(--text-secondary)'}} />
            <Tooltip 
              cursor={{fill: 'var(--bg-color)'}} 
              contentStyle={{ borderRadius: '8px', border: '1px solid var(--border-color)', boxShadow: '0 4px 6px rgba(0,0,0,0.05)' }} 
            />
            <Bar dataKey="value" fill="var(--accent-color)" radius={[4, 4, 0, 0]} barSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default TrainPerformanceChart;